import { SettlementVenue, Sponsor, TradingEntity } from 'api'
import { isNil } from 'lodash-es'

export const FICC_CLEARING_HOUSE_ID = 'e7e109c8'

export function createSponsorFromCounterparty(counterparty: TradingEntity | null): Sponsor | null {
  if (isNil(counterparty)) {
    return null
  }

  return {
    clearingHouseIds: [FICC_CLEARING_HOUSE_ID],
    id: counterparty.id,
    lei: counterparty.lei,
    longName: counterparty.publishedName,
    publishedName: counterparty.shortName
  }
}

export function shouldResetCsd(settlementVenue: SettlementVenue) {
  if (settlementVenue && [SettlementVenue.Direct, SettlementVenue.Sponsored].includes(settlementVenue)) {
    return true
  }

  return false
}
